import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'
import { AlertController } from 'ionic-angular'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map'

import { httpHost } from '../config'


import { Store } from '@ngrx/store'
import { AppState } from '../reducers'
import { ICaption, ICaptionsInfo } from '../models'
import { LectureApiBase } from './lecture-api'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class YouTubeCaptionApi {
  protected infoUrlBase: string

  constructor(
    private api: LectureApiBase,
    private translateSvc: TranslateService
  ) {}

  videoApiPath(videoId: string) {
    return `ytcaption/video/?video_id=${videoId}&accept_language=${this.translateSvc.getBrowserCultureLang()}`
  }

  fromUri2CaptionApiPath(url: string) {
    let query = url.split('?')[1]
    return `ytcaption/caption/?${query}`
  }

  getCaptionsInfo(videoId: string): Observable<string> {
    return this.api.getRaw(this.videoApiPath(videoId))
  }

  getCaptions(url: string): Observable<string>{
    return this.api.getRaw(this.fromUri2CaptionApiPath(url))
  }

  private makeInfoUrl(videoId: string): string { return `${this.infoUrlBase}${videoId}` }
}



// WEBPACK FOOTER //
// ./src/apis/youtube-caption.ts